<template>
  <div>
    <h2 class="ViewHeading">Shower Accessories</h2>
    <div>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col>
          <b-card-group deck
            ><b-card
              border-variant="info"
              header="In Stock"
              header-bg-variant="info"
              align="center"
            >
              <b-card-text
                >You currently have {{ this.StockCount }} accessory sets
                unassigned</b-card-text
              >
              <b-card-text></b-card-text> </b-card
            ><b-card
              border-variant="warning"
              header="Due Replacement"
              header-bg-variant="warning"
              align="center"
            >
              <b-card-text
                >You have {{ this.DueCount }} accessory sets due for replacement
                in the next 28 days</b-card-text
              >
            </b-card>
            <b-card
              border-variant="danger"
              header=" Overdue Replacement"
              header-bg-variant="danger"
              align="center"
            >
              <b-card-text
                >You have {{ this.OverdueCount }} accessory set that is overdue
                for replacement</b-card-text
              >
              <b-card-text></b-card-text>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <b-row><br /></b-row>
    </div>
    <div>
      <b-card no-body>
        <b-tabs card v-model="FilterTabs">
          <b-tab title="Tracked Accessories" active>
            <!-- List Similar to others showing ID, outlet ID, last changed, due
              changed etc. <br />
              Shower Accessories by Devices. -->

            <div id="Table">
              <br />
              <h4>Tracked Accessories</h4>
              <br />
              <div>
                <b-table
                  sticky-header
                  no-border-collapse
                  responsive
                  :items="TrackedAccessories"
                  :fields="TrackedAccessoriesFields"
                  hover
                  small
                >
                  <template v-slot:cell(8)="{ item }">
                    <div v-if="item[8] === 'Overdue'">
                      <b-badge variant="danger">Overdue</b-badge>
                    </div>
                    <div v-if="item[8] === 'Due'">
                      <b-badge variant="warning">Due</b-badge>
                    </div>
                    <div v-if="item[8] === 'Valid'">
                      <b-badge variant="success">Valid</b-badge>
                    </div>
                  </template>
                  <template v-slot:cell(11)="{ item }">
                    <b-button
                      variant="outline-info"
                      size="sm"
                      v-on:click="showFilterNotes(item)"
                      >Show</b-button
                    >
                  </template>
                </b-table>
              </div>
            </div>
          </b-tab>

          <b-modal
            id="TrackedDetails"
            ref="TrackedDetails"
            title="Shower Accessory Management"
            ok-only
            ok-variant="outline-info"
          >
            <h3>{{ DetailsOutletID }}</h3>

            <b-card :header-bg-variant="statusColour">
              <template #header>
                Status: {{ DetailsStatus }} - {{ DetailsDueReplaced }}
              </template>
              <b-row>
                <b-col class="text-center">
                  <h4>{{ DetailsAccessory }}</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b>Colour: </b> <em>{{ DetailsColour }}</em>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col
                  ><b>Room: </b> <em>{{ DetailsRoom }}</em></b-col
                >
              </b-row>
              <b-row>
                <b-col
                  ><b>Location: </b> <em>{{ DetailsLocation }}</em>
                </b-col>
              </b-row>

              <br />
              <b-row
                ><b-col
                  ><b>Description: </b> <em>{{ DetailsDescription }}</em></b-col
                >
              </b-row>
              <br />
              <b-row>
                <b-col>
                  <b>Last Changed: </b> <em>{{ DetailsLastChanged }}</em>
                </b-col>
              </b-row>
              <br />
              <b-row v-if="DetailsStatus == 'Overdue'">
                <b-col>
                  <b-button
                    variant="outline-info"
                    v-on:click="
                      goToInstallFilter(DetailsOutletID, DetailsAccessory)
                    "
                  >
                    Install Shower Accessory
                  </b-button>

                  <b-button
                    variant="outline-info"
                    v-on:click="showerClear(DetailsOutletID)"
                  >
                    Clear Shower Alert
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-modal>

          <b-tab title="Maintenance Schedule" lazy>
            <div id="Table">
              <br />
              <h4>Scheduled Accessory Maintenance</h4>
              <br />
              <div>
                <b-table
                  sticky-header
                  no-border-collapse
                  responsive
                  :items="scheduleditems"
                  :fields="scheduledfields"
                  hover
                  small
                >
                  <!-- <template v-slot:cell(Modify)="{ item }">
                    <b-button
                      v-b-modal.modal-11
                      size="sm"
                      variant="outline-info"
                      v-on:click="modifyMaintenanceBooking(item)"
                      >Modify</b-button
                    >
                  </template> -->

                  <template v-slot:cell(Modify)="{ item }">
                    <b-button
                      v-if="
                        item[13] == 'FALSE' ||
                          item[13] == '' ||
                          item[13] == null
                      "
                      size="sm"
                      variant="outline-info"
                      v-on:click="modifyMaintenanceBooking(item)"
                      >Modify</b-button
                    >
                    <b-badge v-if="item[13] == 'TRUE'">Under Edit</b-badge>
                  </template>
                </b-table>
                <b-row>
                  <b-col class="text-left">
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      v-on:click="ShowNewBooking()"
                      ><BIconPlus></BIconPlus>
                      Schedule New Maintenance
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-tab>
          <b-modal
            id="ModifyMaintenance"
            ref="ModifyMaintenance"
            title="Modify Maintenance Appointment"
            header-bg-variant="light"
            header-text-variant="dark"
            hide-footer
          >
            <b-card>
              <b-row class="mt-2">
                <b-col cols="4" class="modify-text-left">Outlet ID</b-col>

                <b-col cols="8">
                  {{ ModifiedBooking.OutletID }}
                </b-col>
              </b-row>
              <b-row class="mt-2"
                ><b-col cols="4" class="modify-text-left">Location</b-col>
                <b-col cols="8">
                  {{ ModifiedBooking.Location }}
                </b-col>
              </b-row>
              <b-row class="mt-2"
                ><b-col cols="4" class="modify-text-left">Room/Area</b-col>
                <b-col cols="8"
                  ><input type="text" required v-model="ModifiedBooking.Area" />
                </b-col>
              </b-row>
              <b-row class="mt-2"
                ><b-col cols="4" class="modify-text-left">Service Note</b-col>
                <b-col cols="8"
                  ><input
                    type="text"
                    v-model="ModifiedBooking.Description"
                    required
                  />
                </b-col>
              </b-row>
              <b-row class="mt-2"
                ><b-col cols="4" class="modify-text-left">Arranged By</b-col>
                <b-col cols="8">
                  {{ ModifiedBooking.ArrangedBy }}
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col class="boldLabel"
                  >Scheduled Date:
                  <b-form-datepicker
                    locale="en"
                    :placeholder="this.ModifiedBooking.Date"
                    v-model="ModifiedBooking.Date"
                  ></b-form-datepicker
                ></b-col>
              </b-row>
              <b-row>
                <b-col class="boldLabel"
                  >Scheduled Time:
                  <b-form-timepicker
                    locale="en"
                    :placeholder="this.ModifiedBooking.Time"
                    v-model="ModifiedBooking.Time"
                  ></b-form-timepicker
                ></b-col>
              </b-row>
              <b-row
                ><b-col><br /></b-col
              ></b-row>
              <b-row>
                <b-col
                  ><b-button
                    variant="outline-info"
                    v-on:click="SubmitModifiedBooking()"
                    >Submit Changes</b-button
                  ></b-col
                >
                <b-col
                  ><b-button
                    variant="outline-info"
                    v-on:click="CancelModifiedBooking()"
                    >Cancel Changes</b-button
                  ></b-col
                >
              </b-row>
              <b-row
                ><b-col><br /></b-col
              ></b-row>
            </b-card>
          </b-modal>
          <b-tab title="Install Accessories">
            <br />
            <b-row>
              <b-col class="text-center">
                <h4>Accessory Install Form</h4>
              </b-col>
            </b-row>
            <br />

            <b-row class="mt-2"
              ><b-col cols="4" class="modify-text-left">Name</b-col>
              <b-col cols="8">{{ this.name }} </b-col>
            </b-row>
            <br />

            <b-row class="mt-2">
              <b-col cols="4">Type</b-col>
              <b-col cols="8">
                <b-form-select
                  id="Type"
                  v-model="InstallForm.Type"
                  :options="Accessories"
                  required
                  v-on:change="updateAccessoryLists()"
                ></b-form-select
              ></b-col>
            </b-row>
            <br />
            <section v-if="ShowForm == true">
              <b-row class="mt-2">
                <b-col cols="4">Accessory ID</b-col>
                <b-col cols="8"
                  ><b-form-select
                    v-model="InstallForm.accessoryID"
                    :options="accessoryID"
                    required
                  ></b-form-select
                ></b-col>
              </b-row>
              <br />
              <b-row class="mt-2">
                <b-col cols="4">Outlet ID</b-col>
                <b-col cols="8"
                  ><b-form-select
                    v-model="InstallForm.OutletID"
                    :options="outletID"
                    required
                  ></b-form-select
                ></b-col>
              </b-row>
              <br />
              <b-row class="mt-2">
                <b-col cols="4">Choose Date</b-col>
                <b-col cols="8"
                  ><b-form-datepicker
                    v-model="InstallForm.Date"
                  ></b-form-datepicker
                ></b-col>
              </b-row>
              <br />
              <b-row class="mt-2">
                <b-col cols="4">Choose Time</b-col>
                <b-col cols="8">
                  <b-form-timepicker
                    locale="en"
                    placeholder=""
                    v-model="InstallForm.Time"
                  ></b-form-timepicker
                ></b-col>
              </b-row>
              <br />
              <b-row>
                <b-col></b-col>
                <b-col class="text-center"
                  ><b-button
                    variant="outline-info"
                    small
                    v-on:click="SubmitInstall()"
                    >Submit</b-button
                  ></b-col
                >
                <b-col class="text-center">
                  <b-button
                    variant="outline-danger"
                    small
                    v-on:click="ResetInstall()"
                    >Reset</b-button
                  ></b-col
                >
                <b-col></b-col>
              </b-row>
            </section>
          </b-tab>
          <b-tab title="Current Stock">
            <!-- List Similar to others showing ID, outlet ID, last changed, due
              changed etc. <br />
              List of current unassigned stock in location. -->
            <div id="Table">
              <br />
              <h4>Current Stock</h4>
              <br />
              <div>
                <b-card-Group>
                  <b-card header="Accessory Packs" header-bg-variant="light">
                    <b-card-group>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Red</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="redcount">
                                {{ this.LocationAccessoryStock.Red }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Blue</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="bluecount">
                                {{ this.LocationAccessoryStock.Blue }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                    </b-card-group>
                    <b-card-group>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Purple</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="purplecount">
                                {{ this.LocationAccessoryStock.Purple }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Green</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="greencount">
                                {{ this.LocationAccessoryStock.Green }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                    </b-card-group>
                    <br />
                  </b-card>
                  <b-card header="Shower Heads Only" header-bg-variant="light">
                    <b-card-group>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Red</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="redcount">
                                {{ this.LocationHeadStock.Red }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Blue</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="bluecount">
                                {{ this.LocationHeadStock.Blue }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                    </b-card-group>
                    <b-card-group>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Purple</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="purplecount">
                                {{ this.LocationHeadStock.Purple }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Green</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="greencount">
                                {{ this.LocationHeadStock.Green }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                    </b-card-group>
                    <br />
                  </b-card>
                  <b-card header="Shower Hoses Only" header-bg-variant="light">
                    <b-card-group>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Red</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="redcount">
                                {{ this.LocationHoseStock.Red }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Blue</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="bluecount">
                                {{ this.LocationHoseStock.Blue }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                    </b-card-group>
                    <b-card-group>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Purple</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="purplecount">
                                {{ this.LocationHoseStock.Purple }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                      <b-card>
                        <b-row align-v="center">
                          <b-col>Green</b-col>
                          <b-col
                            ><b-avatar rounded variant="light"
                              ><p class="greencount">
                                {{ this.LocationHoseStock.Green }}
                              </p></b-avatar
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                    </b-card-group>
                    <br />
                  </b-card>
                </b-card-Group>
                <br />
              </div>
            </div>
          </b-tab>
          <b-tab lazy title="Completed">
            <br />
            <h4 class="centered">Completed Changes</h4>
            <br />
            <b-table
              sticky-header
              no-border-collapse
              responsive
              hover
              small
              show-empty
              empty-text="You don't curently have any results to show"
              :items="completeActions"
              :fields="completeActionsHeaders"
            >
            </b-table>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <b-modal
      ref="NewBookingModal"
      id="NewBookingModal"
      title="New Maintenance Booking"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card
        header-bg-variant="dark"
        border-variant="light"
        bg-variant="light"
      >
        <template #header>
          <h6 class="testHeader">New Maintenance Request Form</h6>
        </template>
        <template #footer>
          <b-row>
            <b-col class="centered">
              <b-button
                v-on:click="SubmitBooking()"
                variant="outline-info"
                small
                >Submit</b-button
              >
              <b-button v-on:click="ResetBooking()" variant="outline-info" small
                >Cancel</b-button
              >
            </b-col>
          </b-row>
        </template>
        <!-- <h5 class="accessoriesHeader">Request Type</h5> -->
        <!-- <b-row>
          <b-col>
            <b-form-select
              :options="TestType"
              v-model="newBooking.TestType"
            ></b-form-select>
          </b-col>
        </b-row>
        <br />
        <hr /> -->

        <b-row>
          <b-col>
            <b-form-input
              id="OutletID"
              v-model="newBooking.NoOfOutlets"
              placeholder="No of Outlets"
              required
            ></b-form-input>
          </b-col>
          <b-col>
            <b-form-input
              id="Area"
              v-model="newBooking.Room"
              placeholder="Room/Area"
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-input
              id="LocationNote"
              v-model="newBooking.Note"
              placeholder="Location Note"
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <hr />
        <b-row
          ><b-col>
            <h5 class="accessoriesHeader">Date</h5>

            <b-form-datepicker
              id="input-4"
              v-model="newBooking.Date"
              class="mb-2"
            ></b-form-datepicker>
          </b-col>
          <b-col>
            <h5 class="accessoriesHeader">Time</h5>

            <b-form-timepicker
              locale="en"
              v-model="newBooking.Time"
            ></b-form-timepicker>
          </b-col>
        </b-row>
        <hr />
        <h5 class="accessoriesHeader">Contact Information</h5>
        <b-row>
          <b-col>
            <b-form-input
              id="input-2"
              v-model="newBooking.Name"
              placeholder="Enter name"
              required
            ></b-form-input>
          </b-col>

          <b-col>
            <b-form-input
              placeholder="Email Address"
              v-model="newBooking.Email"
            ></b-form-input>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-input
              id="input-2"
              v-model="newBooking.ContactNote"
              placeholder="Note for Contact"
              required
              max="150"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { BIconPlus } from "bootstrap-vue";

export default {
  computed: {},
  components: { BIconPlus },

  data() {
    return {
      FilterTabs: 0,
      ShowForm: false,
      TrackedAccessories: [],
      TrackedAccessoriesFields: [
        { key: "0", label: "Outlet ID", variant: "primary" },
        { key: "10", label: "Accessory ID" },
        { key: "2", label: "Room" },
        { key: "9", label: "Location" },
        { key: "3", label: "Position" },
        { key: "4", label: "Accessory type" },
        { key: "5", label: "Colour" },
        { key: "6", label: "Last Changed" },
        { key: "7", label: "Due Replaced" },
        { key: "8", label: "Status" },
        { key: "11", label: "Details" },
      ],
      response: null,
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      completeActionsHeaders: [
        {
          key: "0",
          label: "Outlet ID",
          variant: "primary",
        },
        { key: "7", label: "Room" },
        { key: "6", label: "Location" },
        { key: "1", label: "Action Type" },
        { key: "2", label: "Description" },
        { key: "3", label: "Date Installed" },
        { key: "4", label: "Time Installed" },
        { key: "5", label: "Changed By" },
      ],

      completeActions: [],

      scheduledfields: [
        {
          key: "0",
          label: "Service ID",
          stickyColumn: true,
          variant: "primary",
        },
        { key: "9", label: "Outlet ID" },
        { key: "1", label: "Type" },
        { key: "2", label: "Category" },
        { key: "3", label: "Service Note" },
        { key: "4", label: "Room/Area" },
        { key: "5", label: " Location Note" },
        { key: "6", label: "Arranged By" },
        { key: "7", label: "Scheduled Date" },
        { key: "8", label: "Scheduled Time" },
        { key: "Modify" },
      ],
      scheduleditems: {},
      selectedlocation: localStorage.getItem("CurrentLocation"),
      name: localStorage.getItem("fullname"),
      item: {},
      ActionVariant: "",
      PassActionID: "",
      PassOutletID: "",
      PassActionType: "",
      Accessories: [
        // { text: "Select Accessory Type", value: null, disabled: true },
        // { text: "Shower Pack Install", value: "ShowerPack" },
        // { text: "Shower Head Install", value: "ShowerHead" },
        // { text: "Shower Hose Install", value: "ShowerHose" },
      ],
      accessoryID: [],
      outletID: [],
      DetailsOutletID: "",
      DetailsLocation: "",
      DetailsRoom: "",
      DetailsDescription: "",
      DetailsFilterType: "",
      DetailsLastChanged: "",
      DetailsDueReplaced: "",
      DetailsStatus: "",
      DetailsAccessory: "",
      DetailsColour: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      item5: "",
      item6: "",
      item7: "",
      StockCount: "",
      DueCount: "",
      OverdueCount: "",
      StockType: "",
      newBooking: {
        NoOfOutlets: null,
        Room: null,
        Note: null,
        CheckType: null,
        Name: null,
        Type: null,
        Date: null,
        Email: null,
      },
      ModifiedBooking: {
        OutletID: null,
        Area: null,
        Description: null,
        Type: null,
        ArrangedBy: null,
        Date: null,
        Time: null,
        Location: null,
        ServiceID: null,
      },
      InstallForm: {
        name: null,
        Type: null,
        Date: null,
        accessoryID: null,
        OutletID: null,
        Time: null,
      },
      TestType: [
        // { text: "Install Type", value: null, disabled: true },
        // { text: "Shower Pack Install", value: "Shower Pack Install" },
        // { text: "Shower Head Only Install", value: "Shower Head Install" },
        // { text: "Shower Hose Only Install", value: "Shower Hose Install" },
      ],
      LocationAccessoryStock: "",
      LocationHeadStock: "",
      LocationHoseStock: "",
      selected: null,
      statusColour: "",
      accessoryIDForSubmit: "",
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrlOutlets =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/outlets";
    let LookUpHeadersOutlets = this.$apikeyPost;
    let LookUpRequestOutlets = {
      RequestType: "LoadOutletIDsLocation",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };

    axios
      .post(LookUpUrlOutlets, LookUpRequestOutlets, LookUpHeadersOutlets)
      .then((response) => {
        response;
        this.outletID = response.data.Values;
        // this.TrackedAccessories = response.data.Values;
      });

    let LookUpUrlAccessories =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersAccessories = this.$apikeyPost;
    let LookUpRequestAccessories = {
      ServiceType: "Accessories",
      RequestType: "LoadTrackedShowerAccessories",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlAccessories,
        LookUpRequestAccessories,
        LookUpHeadersAccessories
      )
      .then((response) => {
        this.TrackedAccessories = response.data.Values;
      });

    let LookUpUrlType =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersType = this.$apikeyPost;
    let LookUpRequestType = {
      ServiceType: "Accessories",
      RequestType: "LoadShowerAccessoryTypes",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpUrlType, LookUpRequestType, LookUpHeadersType)
      .then((response) => {
        for (let i = 0; i < response.data.Values.length; i++) {
          this.Accessories.push({
            text: response.data.Values[i],
            value: response.data.Values[i],
          });
        }
      });

    let LookUpCounts = {
      ServiceType: "Accessories",
      RequestType: "ShowerAccessoryCounts",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpUrlAccessories, LookUpCounts, LookUpHeadersAccessories)
      .then((response) => {
        (this.StockCount = response.data.StockCount),
          (this.OverdueCount = response.data.OverdueCount),
          (this.DueCount = response.data.DueCount);
      });

    let LookUpUrlScheduledChanges =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersScheduledChanges = this.$apikeyPost;
    let LookUpRequestScheduledChanges = {
      ServiceType: "Accessories",
      RequestType: "LoadScheduledShowerAccessories",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlScheduledChanges,
        LookUpRequestScheduledChanges,
        LookUpHeadersScheduledChanges
      )
      .then((response) => {
        this.scheduleditems = response.data.Values;
      });

    let LookUpUrlCurrentStock =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersCurrentStock = this.$apikeyPost;
    let LookUpRequestCurrentStock = {
      ServiceType: "Accessories",
      RequestType: "LoadCurrentShowerStock",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlCurrentStock,
        LookUpRequestCurrentStock,
        LookUpHeadersCurrentStock
      )
      .then((response) => {
        this.LocationAccessoryStock = response.data.Values.ShowerAccessoryPack;
        this.LocationHoseStock = response.data.Values.ShowerHose;
        this.LocationHeadStock = response.data.Values.ShowerHead;
      });

    let LookUpUrlCompleted =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersCompleted = this.$apikeyPost;
    let LookUpRequestCompleted = {
      ServiceType: "Accessories",
      RequestType: "LoadShowerAccessoryChanges",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpUrlCompleted, LookUpRequestCompleted, LookUpHeadersCompleted)
      .then((response) => {
        this.completeActions = response.data.Values;
      });
  },

  methods: {
    showerClear(id) {
      let LookUpUrlScheduledTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduledTests = this.$apikeyPost;
      let LookUpRequestScheduledTests = {
        ServiceType: "Accessories",
        RequestType: "UpdateShowerAccessoryStatus",
        DataDict: [
          {
            Status: "Dormant",
            OutletID: id,
            AccessoryID: this.accessoryIDForSubmit,
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduledTests,
          LookUpRequestScheduledTests,
          LookUpHeadersScheduledTests
        )
        .then((response) => {
          response;
          this.$refs["TrackedDetails"].hide();

          this.resetTracked();
        });
    },

    resetTracked() {
      let LookUpUrlAccessories =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersAccessories = this.$apikeyPost;
      let LookUpRequestAccessories = {
        ServiceType: "Accessories",
        RequestType: "LoadTrackedShowerAccessories",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlAccessories,
          LookUpRequestAccessories,
          LookUpHeadersAccessories
        )
        .then((response) => {
          this.TrackedAccessories = [];
          this.TrackedAccessories = response.data.Values;
        });
    },

    SubmitInstall() {
      if (
        this.InstallForm.Date == null ||
        this.InstallForm.OutletID == null ||
        this.InstallForm.accessoryID == null ||
        this.InstallForm.Type == null ||
        this.InstallForm.Time == null
      ) {
        alert("Please complete all fields to continue");
      } else {
        alert("Installation Successfully Uploaded");

        this.InstallForm.name = localStorage.getItem("fullname");
        let LookUpUrlScheduledTests =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersScheduledTests = this.$apikeyPost;
        let LookUpRequestScheduledTests = {
          RequestType: "AddShowerAccessoryOutlet",
          ServiceType: "Accessories",
          DataDict: [
            {
              Location: this.selectedlocation,
              AccessoryType: this.InstallForm.Type,
              OutletID: this.InstallForm.OutletID,
              AccessoryID: this.InstallForm.accessoryID,
              FittedBy: this.InstallForm.name,
              DateFitted: this.InstallForm.Date,
              InstalledTime: this.InstallForm.Time,
              ServiceID: "",
            },
          ],
        };
        axios
          .post(
            LookUpUrlScheduledTests,
            LookUpRequestScheduledTests,
            LookUpHeadersScheduledTests
          )
          .then((response) => {
            response;
            this.ShowForm = false;

            // this.$refs["newTempBooking"].hide();
            // this.resetScheduledChecks();

            this.InstallForm = {};
          });
        this.ResetInstall();
      }
    },

    goToInstallFilter(id, type) {
      this.$refs["TrackedDetails"].hide();
      this.InstallForm.Type = type;
      this.FilterTabs = 2;
      this.updateAccessoryLists(id);
      // this.InstallForm.OutletID = id;
    },

    ShowNewBooking() {
      this.$refs["NewBookingModal"].show();
    },
    ResetInstall() {
      this.InstallForm = {
        name: null,
        Type: null,
        Date: null,
        accessoryID: null,
        OutletID: null,
      };
      this.selected = null;
    },

    modifyMaintenanceBooking(item) {
      this.ModifiedBooking = {};
      this.ModifiedBooking = {
        OutletID: item[9],
        Area: item[4],
        Description: item[3],
        Type: item[1],
        ArrangedBy: item[6],
        Date: item[7],
        Time: item[8],
        Location: item[5],
        ServiceID: item[0],
      };

      this.$refs["ModifyMaintenance"].show(this.ModifiedBooking);
    },

    SubmitModifiedBooking() {
      // if (
      //   this.ModifiedBooking.Area == "" ||
      //   this.ModifiedBooking.Description == "" ||
      //   this.ModifiedBooking.Type == "" ||
      //   this.ModifiedBooking.ArrangedBy == "" ||
      //   this.ModifiedBooking.Date == "" ||
      //   this.ModifiedBooking.Time == ""
      // ) {
      //   alert("Please complete all fields to submit Booking request");
      // } else {
      //   let LookUpUrl =
      //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      //     this.$environment +
      //     "/service";
      //   let LookUpHeaders = this.$apikeyPost;
      //   this.LookUpRequest = {
      //     RequestType: "ModifyRequest",

      //     RequestVariable: "",

      //     DataDict: [
      //       {
      //         ServiceNote: this.ModifiedBooking.Description,
      //         DeptFloor: this.ModifiedBooking.Area,
      //         LocationNote: "",
      //         ScheduledDate: this.ModifiedBooking.Date,
      //         ScheduledTime: this.ModifiedBooking.Time,
      //         ServiceID: this.ModifiedBooking.ServiceID,
      //       },
      //     ],
      //   };

      //   axios
      //     .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      //     .then((response) => {
      //       response;
      //       alert("Update Submitted");
      //       this.$refs["ModifyMaintenance"].hide();
      //       this.resetBookings();
      //     });
      //   alert("Update Submitted");
      // }

      if (
        this.ModifiedBooking.Area == "" ||
        this.ModifiedBooking.Description == "" ||
        this.ModifiedBooking.Room == "" ||
        this.ModifiedBooking.Date == "" ||
        this.ModifiedBooking.Time == ""
      ) {
        alert("Please complete all fields to submit Booking request");
      } else {
        let EmailService = {
          ToEmail: "Support@seraphprotect.online",

          EmailText:
            "Modify Appointment Request raised by user.\\n\\n" +
            this.selectedlocation +
            "\\n" +
            this.name +
            "\\n\\n" +
            "Appointment Information " +
            "\\n\\n" +
            this.ModifiedBooking.ServiceID +
            "\\n" +
            "Type - " +
            this.ModifiedBooking.Description +
            "\\n " +
            this.ModifiedBooking.Type +
            "\\n" +
            "Room - " +
            this.ModifiedBooking.Room +
            "\\n" +
            "Area  - " +
            this.ModifiedBooking.Area +
            "\\n" +
            "New Date and Time - " +
            this.ModifiedBooking.Date +
            " at " +
            this.ModifiedBooking.Time,

          EmailSubject: "Service Request Booking Modification ",
        };

        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";

        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailService, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Your Request has been submitted,An Angel Guard staff member will be in touch."
        );

        let ScheduledUpdateURL =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/service";
        let ScheduledUpdateHeaders = this.$apikeyPost;
        let ScheduledUpdateRequest = {
          RequestType: "UpdateService",
          RequestVariable: "",
          DataDict: [
            {
              ServiceID: this.ModifiedBooking.ServiceID,
              Status: "",
              UnderEdit: "TRUE",
            },
          ],
        };
        axios
          .post(
            ScheduledUpdateURL,
            ScheduledUpdateRequest,
            ScheduledUpdateHeaders
          )
          .then((response) => {
            response;
            this.resetBookings();
          });
        this.$refs["ModifyMaintenance"].hide();
      }
    },
    resetBookings() {
      let LookUpUrlAccessories =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersAccessories = this.$apikeyPost;
      let LookUpRequestAccessories = {
        ServiceType: "Accessories",
        RequestType: "LoadTrackedShowerAccessories",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlAccessories,
          LookUpRequestAccessories,
          LookUpHeadersAccessories
        )
        .then((response) => {
          this.TrackedAccessories = response.data.Values;
        });

      let LookUpUrlType =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersType = this.$apikeyPost;
      let LookUpRequestType = {
        ServiceType: "Accessories",
        RequestType: "LoadShowerAccessoryTypes",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(LookUpUrlType, LookUpRequestType, LookUpHeadersType)
        .then((response) => {
          for (let i = 0; i < response.data.Values.length; i++) {
            this.Accessories.push({
              text: response.data.Values[i],
              value: response.data.Values[i],
            });
          }
        });

      let LookUpCounts = {
        ServiceType: "Accessories",
        RequestType: "ShowerAccessoryCounts",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(LookUpUrlAccessories, LookUpCounts, LookUpHeadersAccessories)
        .then((response) => {
          (this.StockCount = response.data.StockCount),
            (this.OverdueCount = response.data.OverdueCount),
            (this.DueCount = response.data.DueCount);
        });

      let LookUpUrlScheduledChanges =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduledChanges = this.$apikeyPost;
      let LookUpRequestScheduledChanges = {
        ServiceType: "Accessories",
        RequestType: "LoadScheduledShowerAccessories",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduledChanges,
          LookUpRequestScheduledChanges,
          LookUpHeadersScheduledChanges
        )
        .then((response) => {
          this.scheduleditems = response.data.Values;
        });

      let LookUpUrlCurrentStock =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersCurrentStock = this.$apikeyPost;
      let LookUpRequestCurrentStock = {
        ServiceType: "Accessories",
        RequestType: "LoadCurrentShowerStock",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlCurrentStock,
          LookUpRequestCurrentStock,
          LookUpHeadersCurrentStock
        )
        .then((response) => {
          this.LocationAccessoryStock =
            response.data.Values.ShowerAccessoryPack;
          this.LocationHoseStock = response.data.Values.ShowerHose;
          this.LocationHeadStock = response.data.Values.ShowerHead;
        });

      let LookUpUrlCompleted =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersCompleted = this.$apikeyPost;
      let LookUpRequestCompleted = {
        ServiceType: "Accessories",
        RequestType: "LoadShowerAccessoryChanges",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlCompleted,
          LookUpRequestCompleted,
          LookUpHeadersCompleted
        )
        .then((response) => {
          this.completeActions = response.data.Values;
        });
    },
    CancelModifiedBooking() {
      this.ModifiedBooking = {};
      this.$refs["ModifyMaintenance"].hide();
    },

    SubmitBooking() {
      // let name = localStorage.getItem("fullname");
      this.newBooking.Type = "WMS";
      if (
        this.newBooking.Type == null ||
        this.newBooking.Room == null ||
        this.newBooking.Note == null ||
        this.newBooking.Date == null ||
        this.newBooking.Name == null ||
        this.newBooking.NoOfOutlets == null ||
        this.newBooking.Email == null
      ) {
        alert("Please complete all fields to submit Booking request");
      } else {
        // let LookUpUrlScheduledTests =
        //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        //   this.$environment +
        //   "/service";
        // let LookUpHeadersScheduledTests = this.$apikeyPost;
        // let LookUpRequestScheduledTests = {
        //   RequestType: "CreateRequest",
        //   RequestVariable: "",
        //   DataDict: [
        //     {
        //       OriginID: "",
        //       Type: "WMS",
        //       Category: "Shower Accessory",
        //       ServiceNote:
        //         this.newBooking.NoOfOutlets + " " + this.newBooking.TestType,
        //       EndpointType: "",
        //       EndpointID: "",
        //       Location: this.selectedlocation,
        //       DeptFloor: this.newBooking.Room,
        //       Position: "",
        //       LocationNote: this.newBooking.Note,
        //       ArrangedBy: name,
        //       ScheduledDate: this.newBooking.Date,
        //       ScheduledTime: this.newBooking.Time,
        //       AssignedTo: "",
        //       ContactName: this.newBooking.Name,
        //       ContactEmail: this.newBooking.Email,
        //       ContactNote: this.newBooking.ContactNote,
        //     },
        //   ],
        // };
        // axios
        //   .post(
        //     LookUpUrlScheduledTests,
        //     LookUpRequestScheduledTests,
        //     LookUpHeadersScheduledTests
        //   )
        //   .then((response) => {
        //     response;

        //     this.newBooking = {};
        //   });

        let EmailService = {
          ToEmail: "Support@seraphprotect.online",

          EmailText:
            "New Shower Maintenance Request raised by user.\\n\\n" +
            this.selectedlocation +
            "\\n" +
            this.newBooking.Name +
            "\\n" +
            this.newBooking.Email +
            "\\n" +
            "Contact Note - " +
            this.newBooking.ContactNote +
            "\\n\\n" +
            "Maintenance Information " +
            "\\n\\n" +
            "Maintenance Type - Shower Accessories" +
            "\\n" +
            "Room - " +
            this.newBooking.Room +
            "\\n" +
            "Number of Outlets  - " +
            this.newBooking.NoOfOutlets +
            "\\n" +
            "Location Note " +
            this.newBooking.Note +
            " Date and Time - " +
            this.newBooking.Date +
            " at " +
            this.newBooking.Time,

          EmailSubject: "New Shower Maintenance Booking ",
        };

        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";

        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailService, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Your Request has been submitted,A staff member will be in touch."
        );
        this.ResetBooking();
      }
    },
    ResetBooking() {
      this.newBooking = {};
      this.$refs["NewBookingModal"].hide();
    },

    showFilterNotes(item) {
      if (item[8] == "Valid") {
        this.statusColour = "success";
      } else if (item[8] == "Due") {
        this.statusColour = "warning";
      } else if (item[8] == "Overdue") {
        this.statusColour = "danger";
      } else {
        this.statusColour = "secondary";
      }
      (this.accessoryIDForSubmit = item[10]),
        (this.DetailsOutletID = item[0]),
        (this.DetailsLocation = item[3]),
        (this.DetailsRoom = item[2]),
        (this.DetailsDescription = item[1]),
        (this.DetailsAccessory = item[4]),
        (this.DetailsColour = item[5]),
        (this.DetailsLastChanged = item[6]),
        (this.DetailsDueReplaced = item[7]),
        (this.DetailsStatus = item[8]),
        (this.DetailsLocation = item[9]);
      this.$refs["TrackedDetails"].show();
    },
    updateAccessoryLists(id) {
      let LookUpUrlScheduledTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduledTests = this.$apikeyPost;
      let LookUpRequestScheduledTests = {
        RequestType: "LoadShowerTypeUnassignedIDs",
        ServiceType: "Accessories",
        DataDict: [
          {
            Location: this.selectedlocation,
            AccessoryType: this.InstallForm.Type,
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduledTests,
          LookUpRequestScheduledTests,
          LookUpHeadersScheduledTests
        )
        .then((response) => {
          this.ShowForm = true;
          this.accessoryID = response.data.Values;
          this.InstallForm.accessoryID = "";
          this.InstallForm.OutletID = "";
          this.InstallForm.Date = "";
          this.InstallForm.Time = "";

          if (id != null) {
            this.InstallForm.OutletID = id;
          }

          // this.$refs["newTempBooking"].hide();
          // this.resetScheduledChecks();
        });
    },
  },
  watch: {},
};
</script>

<style>
.modal {
  text-align: center;
}

.redcount {
  color: red;
  margin: auto;
}

.bluecount {
  color: blue;
  margin: auto;
}

.purplecount {
  color: blueviolet;
  margin: auto;
}

.greencount {
  color: green;
  margin: auto;
}

.orderHeader {
  text-align: center;
  color: azure;
  font-size: 20px;
}
.accessoriesHeader {
  text-align: center;
}
.centered {
  text-align: center;
}
</style>
